module.exports = __webpack_public_path__ + "img/fondo_halloween.8207ee1c.png";